<template>
  <div class="finance">
    <div class="px-3 py-5">
      <div v-if="showReports">
        <div class="d-flex flex-column">
          <label class="primary--text f14 fw500 temp">
            {{ localStorage.translations.pages['statistic_project'].tables.period }}
          </label>
          <div class="d-flex flex-wrap">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  hide-details
                  v-model="dateRangeText"
                  filled
                  height="30"
                  v-bind="attrs"
                  readonly
                  prepend-inner-icon="today"
                  placeholder="—"
                  v-on="on"
                  class="temp border-picker"
                />
              </template>
              <v-date-picker
                :locale="$cookies.get('languageSelect').key"
                v-model="period"
                range
                no-title
                show-week
                first-day-of-week="1"
                :max="new Date().toISOString().slice(0, 10)"
              >
                <BaseButton
                  class="ml-auto mr-0"
                  :text="localStorage.translations.pages.common.buttons.confirm"
                  :disabled="period.length < 1"
                  @click=";(menu = false), onUpdateReportData({ resetPeriod: true })"
                />
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </div>
      <div
        v-if="(showReports && reportsData !== null && reportsData.sum > 0) || totalPrice > 0"
        class="primary--text fw500 d-flex justify-space-between mb-2"
      >
        <div>{{ localStorage.translations.pages.common.text.total }}</div>
        <div class="fw700">
          {{
            (showReports ? $formatCurrency(reportsData.sum) : $formatCurrency(totalPrice)) + ' €'
          }}
        </div>
      </div>
      <BaseWidget
        v-if="(showReports && reportsData !== null && reportsData.sum > 0) || totalPrice > 0"
        :items="circularFormatData"
        circular
        :size="800"
        compact
        class="donut mx-auto"
      />
      <Plug v-else />
    </div>
    <div
      v-if="(showReports && reportsData !== null && reportsData.sum > 0) || totalPrice > 0"
      class="px-3 py-3 border"
    >
      <div v-if="showReports">
        <template v-for="(cust, c) in widgetListData">
          <div :key="c + 'main'" class="reportList gap-5 px-2 py-1">
            <div :key="c + 'name'">
              <span class="primary--text f16"> {{ cust.name }} </span>
            </div>
            <div :key="c + 'amount'">
              <span class="f14 text-start primary--text"> {{ cust.text }} </span>
            </div>
            <v-avatar :color="cust.color" size="20px" :key="c + 'avatar'" />
            <div class="d-flex align-center justify-end">
              <span v-if="cust.status && cust.status !== 'new'" class="text-end" :key="c + 'count'">
                {{ cust.count + ' ' + localStorage.translations.pages.common.measure['piece'] }}
              </span>
            </div>
          </div>
          <template v-if="cust.status && cust.status === 'in_progress'">
            <div
              v-for="(item, j) in widgetListTreeData"
              :key="c + '_' + j"
              class="reportList gap-5 px-2 py-1"
            >
              <div :key="c + 'item' + j + 'name'" class="inner">
                <span class="primary--text f16">{{ item.name }}</span>
                <div :class="j === 0 ? 'inner-border-first' : 'inner-border'" />
              </div>
              <div :key="c + 'item' + j + 'amount'">
                <span class="f14 text-start primary--text"> {{ item.text }} </span>
              </div>
              <v-avatar :color="item.color" size="20px" :key="c + 'item' + j + 'avatar'" />
              <span class="text-end" :key="c + 'item' + j + 'count'">{{
                item.count + ' ' + localStorage.translations.pages.common.measure['piece']
              }}</span>
            </div>
          </template>
        </template>
      </div>
      <HomeWidgetInfoItem
        v-else
        v-for="(dataItem, dataItemKey) in data"
        :data="dataItem"
        :key="dataItemKey"
      />
    </div>
  </div>
</template>

<script>
import HomeWidgetInfoItem from './HomeWidgetInfoItem'
import { mapActions, mapMutations } from 'vuex'
import Plug from 'components/Plug.vue'
export default {
  name: 'HomeWidgetFinance',
  props: {
    data: {
      type: Array,
      default: null,
    },
    clearData: {
      type: Object,
    },
    showReports: Boolean,
  },
  components: {
    Plug,
    HomeWidgetInfoItem,
  },
  data: () => ({
    allFields: {
      new: 'var(--v-primary-lighten1)',
      in_progress: 'var(--v-primary-base)',
      approved: 'var(--v-success-lighten5)',
      sent: 'var(--v-warning-lighten1)',
      viewed: 'var(--v-warning-base)',
      expired: 'var(--v-error-base)',
      signed: 'var(--v-success-base)',
    },
    menu: false,
    key: 0,
    period: [],
    lastMonthPeriod: [],
    currentMonth: '',
    reportsData: null,
  }),
  computed: {
    totalPrice() {
      return this.data?.length > 0
        ? this.data.reduce((sum, elem) => {
            return sum + elem.total_price
          }, 0)
        : 0
    },
    circularFormatData() {
      return this.data.map((i) => {
        if (!i.color) {
          i.color = '#' + Math.floor(Math.random() * 16777215).toString(16)
        }
        return i
      })
    },
    dateRangeText() {
      let dates = [...this.period]
      if (dates[0]) {
        dates[0] = this.$formatDate(dates[0])
      }
      if (dates[1]) {
        dates[1] = this.$formatDate(dates[1])
      }
      if (dates[0] && dates[1] && dates[0] > dates[1]) {
        dates = [dates[1], dates[0]]
      }
      return dates.join(' - ')
    },
    widgetListNames() {
      let result = []
      for (let i in this.allFields)
        result.push({
          name: i,
          color: this.allFields[i],
        })
      return result
    },
    widgetListData() {
      let result = []
      let temp = this.reportsData && this.reportsData.statuses

      let names = this.widgetListNames
      for (let n in names) {
        let name = names[n].name
        let color = names[n].color
        if (temp && temp[name]) {
          result.push({
            name: this.localStorage.translations.pages.projects['reports_table'][name] || name,
            color: color,
            status: name,
            count: temp[name].count,
            text: this.$formatCurrency(temp[name].price) + ' €',
            amount: this.$formatCurrency(temp[name].price),
          })
        }
      }
      return result
    },
    widgetListTreeData() {
      let result = []
      let temp = this.reportsData.statuses && this.reportsData.statuses.in_progress.statuses
      let names = this.widgetListNames
      for (let n in names) {
        let name = names[n].name
        let color = names[n].color
        if (temp && temp[name]) {
          result.push({
            name:
              this.localStorage.translations.pages.projects['reports_table'][names[n].name] || name,
            color: color,
            status: name,
            count: temp[name].count,
            text: this.$formatCurrency(temp[name].price) + ' €',
            amount: this.$formatCurrency(temp[name].price),
          })
        }
      }
      return result
    },
  },
  created() {
    if (this.showReports) {
      this.firstPeriodDateData()
      this.onUpdateReportData({})
    }
  },
  updated() {
    if (this.period.length === 0) {
      this.period = localStorage.getItem('periodStatisticReport')
        ? JSON.parse(localStorage.getItem('periodStatisticReport')).period
        : { period: this.period, month: this.currentMonth }
      this.onUpdateReportData({ isUpdate: true })
    }
  },
  methods: {
    ...mapActions('commonWidgets', ['onCommonWidgetReport']),
    ...mapMutations(['setLoadingAnimation']),
    firstPeriodDateData() {
      let currentDate = new Date()
      let dd = currentDate.getDate()
      let mm = currentDate.getMonth() + 1
      let yyyy = currentDate.getFullYear()
      this.period = []
      let currentMonth = new Date(yyyy, mm, 0).getDate()
      let lastMonth = new Date(yyyy, mm - 1, 0).getDate()
      if (currentMonth > lastMonth) {
        let tempDay = dd - (dd - lastMonth)
        this.period.push(
          String(
            yyyy +
              '-' +
              String(mm == 1 ? 12 : mm - 1).padStart(2, '0') +
              '-' +
              String(tempDay).padStart(2, '0'),
          ),
        )
        this.period.push(
          String(yyyy + '-' + String(mm).padStart(2, '0') + '-' + String(dd).padStart(2, '0')),
        )
      } else {
        this.period.push(
          String(
            yyyy +
              '-' +
              String(mm == 1 ? 12 : mm - 1).padStart(2, '0') +
              '-' +
              String(dd).padStart(2, '0'),
          ),
        )
        this.period.push(
          String(yyyy + '-' + String(mm).padStart(2, '0') + '-' + String(dd).padStart(2, '0')),
        )
      }
      this.lastMonthPeriod = this.period
      this.currentMonth = mm
    },
    async onUpdateReportData({ resetPeriod, isUpdate }) {
      let local = localStorage.getItem('periodStatisticReport')
        ? JSON.parse(localStorage.getItem('periodStatisticReport'))
        : { period: this.period, month: this.currentMonth }
      if (resetPeriod || (local && local.month < this.currentMonth)) {
        local.period = this.period
      }
      this.period = local.period
      this.setLoadingAnimation(true)
      let data = { period: this.period }
      if (this.period && this.period.length && this.period[1] && this.period[0] > this.period[1])
        data.period = [this.period[1], this.period[0]]
      if (this.period && this.period.length && !this.period[1]) {
        this.period[1] = this.period[0]
        data.period = [data.period[0], data.period[1]]
      }
      const optFnc = (newReportData) => {
        this.reportsData = newReportData
        this.setLoadingAnimation(false)
        localStorage.setItem(
          'periodStatisticReport',
          JSON.stringify({
            period: data.period,
            month: this.currentMonth,
          }),
        )
      }
      await this.onCommonWidgetReport(data).then((res) => {
        optFnc(res.data)
      })
    },
  },
}
</script>

<style scoped lang="scss">
.finance {
  display: grid;
  grid-template-columns: 1fr;
}
.border-picker {
  border-bottom: 1px solid var(--v-secondary-base);
}
.inner {
  margin-left: 15px;
  position: relative;

  &-border {
    position: absolute;
    top: -90%;
    left: -15px;
    width: 10px;
    height: 140%;
    border-bottom: 1px dashed var(--v-primary-base);
    border-left: 1px dashed var(--v-primary-base);

    &-first {
      position: absolute;
      top: -20%;
      left: -15px;
      width: 10px;
      height: 85%;
      border-bottom: 1px dashed var(--v-primary-base);
      border-left: 1px dashed var(--v-primary-base);
    }

    &-mobile {
      position: absolute;
      top: -60%;
      left: -10px;
      width: 10px;
      height: 120%;
      border-bottom: 1px dashed var(--v-primary-base);
      border-left: 1px dashed var(--v-primary-base);

      &-first {
        position: absolute;
        top: -15%;
        left: -10px;
        width: 10px;
        height: 75%;
        border-bottom: 1px dashed var(--v-primary-base);
        border-left: 1px dashed var(--v-primary-base);
      }
    }
  }
}
.reportList {
  display: grid;
  grid-template-columns: 1.5fr 1fr auto 0.75fr;
}
.donut {
  max-width: 300px;
}
</style>
